import script from "./SearchField.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchField.vue?vue&type=script&setup=true&lang=js"

import "./SearchField.vue?vue&type=style&index=0&id=60bf3903&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60bf3903"]])

export default __exports__